import { render, staticRenderFns } from "./accountCodeLogin.vue?vue&type=template&id=4ffd8931&scoped=true"
import script from "./accountCodeLogin.vue?vue&type=script&lang=ts"
export * from "./accountCodeLogin.vue?vue&type=script&lang=ts"
import style0 from "./accountCodeLogin.vue?vue&type=style&index=0&id=4ffd8931&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd8931",
  null
  
)

export default component.exports